module.exports = __webpack_public_path__ + "img/d06f96fd4f0298aedb597b315a0afc6a.png";